/**
 * Adds a color overlay to an image file. Used for testimonial background images
 * to improve text readability over selected images.
 */
export const addColorOverlayToImage = (file: File, overlayColor: string, opacity: number): Promise<File> =>
	new Promise((resolve, reject) => {
		const img = new Image();
		const url = URL.createObjectURL(file);

		img.onload = () => {
			URL.revokeObjectURL(url);
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			const ctx = canvas.getContext('2d');
			if (!ctx) {
				reject(new Error('Could not get canvas context'));
				return;
			}
			ctx.drawImage(img, 0, 0);
			ctx.fillStyle = overlayColor;
			ctx.globalAlpha = opacity;
			ctx.fillRect(0, 0, canvas.width, canvas.height);
			ctx.globalAlpha = 1;

			canvas.toBlob(blob => {
				if (!blob) {
					reject(new Error('Failed to create blob from canvas'));
					return;
				}
				resolve(new File([blob], file.name, { type: 'image/png' }));
			}, 'image/png');
		};
		img.onerror = () => {
			URL.revokeObjectURL(url);
			reject(new Error('Failed to load image'));
		};
		img.src = url;
	});

/** Default overlay color for testimonial background images (helps with readability.) */
export const TESTIMONIAL_OVERLAY_COLOR = '#505050';
/** Default overlay opacity for testimonial background images. */
export const TESTIMONIAL_OVERLAY_OPACITY = 0.4;
